import dayjs from "dayjs";
import i18n from "i18next";

export const DATE_FORMAT_DASH_TH = "DD/MMM/BBBB";
export const DATE_FORMAT_NUMBER_TH = "DD/MM/YYYY";
export const DATE_FORMAT_FULL_TH = "DD MMM BBBB";
export const FORMAT_FULL_MONTH_YEAR_TH = "MMM BBBB";
export const DEFAULT_DATE_FORMAT = "YYYY-MM-DD";
export const DATE_FORMAT_FULL_EN = "MMM DD, BBBB";

export const formatDateDefault = (date: any) => {
    return dayjs(date).format(DEFAULT_DATE_FORMAT);
};

export const formatToDate = (date: any) => {
    return dayjs(date);
};

export const formatDate = (date: any) => {
    // dayjs.locale("th");
    // return dayjs(date).format(DATE_FORMAT_DASH_TH);
    dayjs.locale("th");
    return dayjs(date).format(DATE_FORMAT_NUMBER_TH);
};

export const formatDateNumber = (date: any) => {
    dayjs.locale("th");
    return dayjs(date).format(DATE_FORMAT_NUMBER_TH);
};

export const formatDateStartEnd = (startDate: any, endDate: any) => {
    let localLang = i18n.language;
    dayjs.locale(localLang || "th");
    // const start = dayjs(startDate).format(
    //     localLang === "en" ? DATE_FORMAT_FULL_EN : DATE_FORMAT_FULL_TH
    // );
    // const end = dayjs(endDate).format(
    //     localLang === "en" ? DATE_FORMAT_FULL_EN : DATE_FORMAT_FULL_TH
    // );
    const start = dayjs(startDate).format(DATE_FORMAT_NUMBER_TH);
    const end = dayjs(endDate).format(DATE_FORMAT_NUMBER_TH);
    return `${start} - ${end}`;
};

export const formatDateFull = (date: any) => {
    // let localLang = i18n.language;
    // dayjs.locale(localLang || "th");
    // return dayjs(date).format(localLang === "en" ? DATE_FORMAT_FULL_EN : DATE_FORMAT_FULL_TH);
    dayjs.locale("th");
    return dayjs(date).format(DATE_FORMAT_NUMBER_TH);
};

export const formatDisplayMonthYear = (date: any) => {
    dayjs.locale("th");
    return dayjs(date).format(FORMAT_FULL_MONTH_YEAR_TH);
};
